import {Component, Input, output} from '@angular/core';
import {DetailedViewObjectService} from "../../../services/detailed-view-object.service";
import {ContextMenuService} from "../../../services/context-menu.service";
import {CTMSMilestone} from "../../../models/ctmsmilestone.model";
import {DataObject} from "../../../models/metadata";
import {
  RdsIconComponent,
} from "@rds/angular-components";


@Component({
  selector: 'app-ctmsmilestone',
  standalone: true,
  imports: [
    RdsIconComponent
],
  templateUrl: './ctmsmilestone.component.html',
  styleUrl: './ctmsmilestone.component.scss'
})
export class CTMSMilestoneComponent {
  @Input() milestone!: CTMSMilestone
  deleteMilestone = output<DataObject>()

  constructor(
    private detailedObjectService: DetailedViewObjectService,
    private contextMenuService: ContextMenuService
  ) {}

  onCardClick() {
    this.detailedObjectService.nextDetailedObject(this.milestone)
  }
  
  onContextMenu(_: MouseEvent) {
    this.contextMenuService.addItemToNextOpen('custom-milestone', () => {
      this.deleteMilestone.emit(this.milestone as DataObject)
    })
  }

  // Contrast helper duplicated from admin tables
  getContrastColor(hexColor?: string | null): string {
    const hex = (hexColor || '').replace('#','');
    if (hex.length !== 6) {
      return '#111827';
    }
    const r = parseInt(hex.substring(0,2), 16);
    const g = parseInt(hex.substring(2,4), 16);
    const b = parseInt(hex.substring(4,6), 16);
    const luminance = (0.299*r + 0.587*g + 0.114*b) / 255;
    return luminance > 0.6 ? '#111827' : '#FFFFFF';
  }
}
